import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CloseIcon from "@mui/icons-material/Close";
import pdfIcon from "../../assets/svg/Pdf.svg";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/system";
import "./pdfCard.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../redux/pre_processor/actions";
import { connect } from "react-redux";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Label from "../Label/Label";

class PdfCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagLabel: "",
      tagName: "",
      fileContent: [],
      expanded: false,
      invalidValidationErrorMessage: "",
      fieldColor: "",
      oldSavedFileNamesWhenSuplementaryFilesTOAdd:
        this.props.oldSavedFileNamesWhenSuplementaryFilesTOAdd || false,
      isSupplementaryPdf: this.props.isSupplementaryPdf || false,
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({
      tagName: this.props.file.tagName ? this.props.file.tagName : "",
    });
  }

  handleExpandClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  handleCheckOrEnter = () => {
    if (/[^a-zA-Z0-9_]/.test(this.state.tagName)) {
      this.setState({
        invalidValidationErrorMessage: "Special characters are not allowed",
      });
    }

    let fileNameWithTag = {
      fileName: this.props.file.fileName,
      tagName:
        this.state.tagName.charAt(0) +
        this.state.tagName.slice(1),
    };

    this.props.addTagName(fileNameWithTag);
  };

  handleTagNameChange = (e) => {
    this.setState({
      tagName: e.target.value,
      invalidValidationErrorMessage: "",
    });
    this.props.handleTagNameChange();
  };

  handleDeletePdf = () => {
    this.props.onRemovePdfAndTag(this.props.file.fileName);
    this.setState({
      tagName: "",
    });
  };

  isDisable = () => {
    let disable = false;

    if (
      (localStorage?.projectType === "free_form" &&
        localStorage?.qc_mapping_status === "done") ||
      // &&
      // localStorage.isCloned === "false"
      (localStorage?.projectType === "template_driven" &&
        localStorage?.template_mapping_status === "done") ||
      //  &&
      // localStorage.isCloned === "false"
      (localStorage?.projectType === "both" &&
        localStorage?.qc_mapping_status === "done" &&
        localStorage?.template_mapping_status === "done")
      //  &&
      // localStorage.isCloned === "false"
    ) {
      return true;
    }

    if (localStorage?.isCloned === "true") {
      if (
        (localStorage?.projectType === "free_form" &&
          localStorage?.qc_mapping_status === "done") ||
        (localStorage?.projectType === "template_driven" &&
          localStorage?.template_mapping_status === "done") ||
        (localStorage?.projectType === "both" &&
          localStorage?.qc_mapping_status === "done" &&
          localStorage?.template_mapping_status === "done")
        // localStorage?.mapData === "true"
      ) {
        disable = true;
      } else return disable;
    }

    if (
      this.state.isSupplementaryPdf &&
      this.state.oldSavedFileNamesWhenSuplementaryFilesTOAdd.indexOf(
        this.props.file.fileName,
      ) === -1
    ) {
      disable = false;
    } else if (
      this.state.isSupplementaryPdf &&
      this.state.oldSavedFileNamesWhenSuplementaryFilesTOAdd.indexOf(
        this.props.file.fileName,
      ) >= 0
    ) {
      disable = true;
    }
    //  else if (
    //   localStorage.mapData === "true" &&
    //   localStorage.isCloned === "false"
    // ) {
    //   disable = true;
    // }

    return disable;
  };

  render() {
    return (
      <Card className="outerPDf-wrapper">
        {/* <CardHeader
          className="Pdf-headerName"
          avatar={<img src={pdfIcon} alt="pdf"></img>}
          sx={{ maxWidth: "18px !important" }}
          subheader={
            <div style={{ maxWidth: "200px", overflowWrap: "break-word" }}>
              <Typography variant="body1">
                KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK
              </Typography>
            </div>
          }
          action={
            <IconButton
              disabled={this.isDisable()}
              onClick={(e) => this.handleDeletePdf()}
            >
              <CloseIcon className="Pdf-close" />
            </IconButton>
          }
        /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            // justifyContent: "space-evenly",
            padding: "10px",
          }}
        >
          <img src={pdfIcon} alt="pdf" height="20px"></img>

          <div
            style={{
              maxWidth: "215px",
              overflowWrap: "break-word",
              paddingLeft: "10px",
            }}
          >
            <Label text={this.props.file.fileName}></Label>
          </div>

          <IconButton
            disabled={this.isDisable()}
            onClick={(e) => this.handleDeletePdf()}
            sx={{ padding: "0px !important", marginLeft: "auto" }}
          >
            <CloseIcon className="Pdf-close" />
          </IconButton>
        </div>

        <CardContent className="card-wrapper">{/* Content */}</CardContent>
        <CardContent className="card-wrapper">
          <Box className="wrapper">
            <TextField
              className="pdf-textfield"
              disabled={this.props.file.isChecked || this.isDisable()}
              size="small"
              error={this.state.invalidValidationErrorMessage}
              onChange={this.handleTagNameChange}
              multiline
              value={this.state.tagName}
              onKeyPress={(e) => e.key === "Enter" && this.handleCheckOrEnter()}
              placeholder="Tag Name"
            />
            {this.props.file.isChecked ? (
              <IconButton
                className="pdfCard-icon"
                disabled={this.isDisable()}
                onClick={(e) => {
                  this.props?.handleEditTagName(this.props.file.fileName);
                  this.setState({
                    fieldColor: "var(--colorTextWhite)",
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            ) : (
              <IconButton
                disabled={this.isDisable() || this.state.tagName === ""}
                className="pdfCard-icon"
                onClick={(e) => {
                  this.handleCheckOrEnter(e, true);
                  this.setState({
                    fieldColor: "#ECECEC",
                  });
                }}
              >
                <CheckBoxIcon />
              </IconButton>
            )}
          </Box>
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfCard);
